/**
 * External dependencies
 */
import React from 'react';

/**
 * Internal dependencies
 */
import logoWhite from 'assets/images/tower_logo_white.png';

/**
 * Style dependencies
 */
import './styles.scss';

const Preloader = ({ isCompact, completed = 0, total = 0, lastLabel = '' }) => {
    if (isCompact) {
        return <div className='preloader-spinner preloader-spinner--dark' />;
    }

    const percent = total > 0 ? Math.round((completed / total) * 100) : 0;

    return (
        <div className='preloader'>
            <div className='preloader__inner'>
                <img src={logoWhite} alt='Tower Systems' className='preloader__logo' />
                <div className='preloader__progress'>
                    <div className='preloader__progress-bar'>
                        <div className='preloader__progress-fill' style={{ width: `${percent}%` }} />
                    </div>
                    <div className='preloader__progress-meta'>
                        <span className='preloader__progress-label'>
                            {total > 0 ? `Loading your profile ${completed} / ${total}` : 'Loading your profile…'}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Preloader;
